import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { Toast } from './components/ui/Toast';
import { ScrollToTop } from './components/ScrollToTop';
import { MainLayout } from './components/layout/MainLayout';
import { DashboardLayout } from './components/layout/DashboardLayout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { LandingPage } from './pages/Landing/LandingPage';
import { LoginPage } from './pages/Auth/LoginPage';
import { RegisterPage } from './pages/Auth/RegisterPage';
import { VerifyEmailPage } from './pages/Auth/VerifyEmailPage';
import { ForgotPasswordPage } from './pages/Auth/ForgotPasswordPage';
import { DashboardPage } from './pages/Dashboard/DashboardPage';
import { PlansPage } from './pages/Subscription/PlansPage';
import { PaymentPage } from './pages/Subscription/PaymentPage';
import { GuidePage } from './pages/Guide/GuidePage';
import { ReportPage } from './pages/Report/ReportPage';
import { ReferralPage } from './pages/Referral/ReferralPage';
import { SettingsPage } from './pages/Settings/SettingsPage';
import { AdminDashboard } from './pages/Admin/AdminDashboard';
import { AdminUsers } from './pages/Admin/AdminUsers';
import { AdminReports } from './pages/Admin/AdminReports';
import { AdminPromocodes } from './pages/Admin/AdminPromocodes';
import { AdminNodes } from './pages/Admin/AdminNodes';
import { NotFoundPage } from './pages/NotFound/NotFoundPage';

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toast />
          <Routes>
            {/* Public routes with MainLayout */}
            <Route element={<MainLayout />}>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>

            {/* Protected dashboard routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="plans" element={<PlansPage />} />
              <Route path="payment/:planId" element={<PaymentPage />} />
              <Route path="payment/success" element={<DashboardPage />} />
              <Route path="guide" element={<GuidePage />} />
              <Route path="support" element={<ReportPage />} />
              <Route path="referral" element={<ReferralPage />} />
              <Route path="settings" element={<SettingsPage />} />

              {/* Admin routes */}
              <Route path="admin" element={<AdminDashboard />} />
              <Route path="admin/users" element={<AdminUsers />} />
              <Route path="admin/reports" element={<AdminReports />} />
              <Route path="admin/promocodes" element={<AdminPromocodes />} />
              <Route path="admin/nodes" element={<AdminNodes />} />

              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
